import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SAlert } from 'shj-components'
import { Button, Spin, message } from 'antd'
import { useSetState } from 'ahooks'
import { initiateSchemeReview, submitSchemeReview } from '@/services/order'
interface IProps {
  title: string
  quoteId: string
  open: boolean
  setOpen: (open: boolean) => void,
  reload?: () => void
}
export default function ProgramProcessModal(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, quoteId, reload = () => ({}) } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    errInfo: [],
  })

  useEffect(() => {
    console.log('open---->', open)
    if (open) {
      setState({ loading: true })
      initiateSchemeReview({
        params: {
          quoteBudgetId: quoteId,
        }
      })
        .then(res => {
          console.log('res---->', res)
          setState({ errInfo: res })
        })
        .finally(() => {
          setState({ loading: false })
        })

    }
  }, [open])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = async () => {
    setState({ loading: true })
    try {
      const res = await submitSchemeReview({
        params: {
          quoteBudgetId: quoteId,
        }
      })
      setState({ loading: false })
      if (typeof res === 'string') {
        message.success('提交成功');
        setOpen(false)
        reload()
      }
    } catch (err) {
      setState({ loading: false });
      console.log(err)
    }
  }

  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }

  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={1000}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            <Button
              disabled={(state.errInfo?.merchOverflowErrorInfo || state.errInfo?.packagetDrawingErrorInfo || state.errInfo?.budgetDetailErrorInfos?.length)}
              style={{ marginLeft: 15 }}
              loading={state.loading}
              type="primary"
              onClick={onsubmit}
            >
              提交审核
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <p>
              <span>1、当前报价方案以及整装图纸需要提交审核，请确保方案及图纸已完成再提交审核</span>
            </p>
            <p>
              <span>2、提交后将发起审核工单、可在我发起的工单中查看审核进度，审核通过后，设计师可以手动发起合同并推送给客户进行签约</span>
            </p>
            {
              (state.errInfo?.merchOverflowErrorInfo || state.errInfo?.packagetDrawingErrorInfo || state.errInfo?.budgetDetailErrorInfos?.length) ? <div style={{ color: 'red', fontWeight: 'bold', marginTop: '10px', fontSize: '16px' }}>
                发起方案审核失败，失败原因如下，请检查后重试：
              </div> : null
            }
            {
              state.errInfo?.merchOverflowErrorInfo ? (
                <div style={{ marginTop: '8px', fontSize: '14px' }}>
                  <div style={{ color: 'red' }}>1. { state.errInfo?.merchOverflowErrorInfo }</div>
                </div>
              ) : null
            }
            {
              state.errInfo?.packagetDrawingErrorInfo ? (
                <div>
                    <div style={{ color: 'red', fontSize: '14px' }}>{state.errInfo?.merchOverflowErrorInfo ? '2. ' : '1. ' }{ state.errInfo?.packagetDrawingErrorInfo }</div>
                </div>
              ) : null
            }
            {
              state.errInfo?.budgetDetailErrorInfos?.length ? (
                <div>
                  <div style={{ color: 'red', fontSize: '14px' }}>
                    {(state.errInfo?.packagetDrawingErrorInfo && state.errInfo?.merchOverflowErrorInfo)
                      ? '3. ' : (state.errInfo?.packagetDrawingErrorInfo || state.errInfo?.merchOverflowErrorInfo)
                      ?  '2. ' : '1. '
                    }当前报价选材未完成，请根据下方提示完善后再试
                  </div>
                  <div style={{ marginTop: '8px', padding: '16px', border: '1px solid #DFE1E5', borderRadius: '8px' }}>
                    <div style={{color: 'red', fontWeight: 'bold', fontSize: '14px', marginBottom: '8px' }}>报价选材异常信息：</div>
                    {state.errInfo?.budgetDetailErrorInfos?.map((item: any, index: number) => {
                      return (
                        <p style={{color: 'red'}}>
                          <span>
                            {index + 1}. {item}
                          </span>
                        </p>
                      )
                    })}
                  </div>
                </div>
              ) : null
            }
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
